import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IObligationInstance, obligationInstancesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const OBLIGATION_INSTANCE_MODULE = 'obligationInstance';

const dataObjectModule = getDataObjectsModule<IObligationInstance>(obligationInstancesManager, 3);
const searchModule = getSearchModule<IObligationInstance>(obligationInstancesManager);

const obligationInstanceModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(OBLIGATION_INSTANCE_MODULE, obligationInstanceModuleInstance);

export { OBLIGATION_INSTANCE_MODULE };
